'use client'

import { cn } from '@/util/cn'
import { useQueryStates } from 'nuqs'
import { TargetLanguage } from '../types'
import { maxLangs, tooManyLangs } from '../util/constants'
import { tlArrayParser } from '../util/get-search-params'
import { showModal } from '../util/modal'

type Props = { targetLanguages: Readonly<TargetLanguage[]> }

const LangList = ({ targetLanguages: allLangs }: Props) => {
    const [langQS, setQs] = useQueryStates({
        tl: tlArrayParser,
        ftl: tlArrayParser,
    })
    return allLangs.map((key) => {
        const isActive = langQS.ftl.includes(key.code)
        return (
            <div
                key={key.code}
                className={cn('btn btn-block md:w-auto', isActive && 'btn-primary')}
                onClick={() => {
                    if (langQS.ftl.includes(key.code)) {
                        setQs({
                            tl: langQS.tl.filter((tl) => tl !== key.code),
                            ftl: langQS.ftl.filter((ftl) => ftl !== key.code),
                        })
                    } else {
                        if (langQS.ftl.length <= maxLangs) {
                            setQs({
                                tl: [...langQS.tl, key.code],
                                ftl: [...langQS.ftl, key.code],
                            })
                        } else {
                            showModal(tooManyLangs)
                        }
                    }
                }}
            >
                {key.name}
            </div>
        )
    })
}

export default LangList
